import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'

dayjs.extend(relativeTime)
dayjs.locale('fr')

export default function allComments({ replyTo, comments }) {
  return (
    <div>
      {comments.map((thisComment) => (
        <div key={thisComment.node.id} className="mb-12">
          <Commentcomp
            authorName={thisComment.node.author.node?.name}
            content={thisComment.node.content}
            publishedDate={thisComment.node.date}
          />

          <div className="mt-4 pl-12 space-y-4">
            {thisComment.node.childs.map((thisChild) => (
              <div key={thisChild.node.id} className="">
                <Commentcomp
                  authorName={thisChild.node.author.node?.name}
                  content={thisChild.node.content}
                  publishedDate={thisChild.node.date}
                />
              </div>
            ))}
          </div>
          <button
            className="mt-4 px-4 py-1.5 text-orange text-base border border-orange focus:outline-none focus:ring-orange focus:ring-offset-2 focus:ring-2"
            onClick={() => replyTo(thisComment.node.databaseId)}>
            Répondre à cette discution
          </button>
        </div>
      ))}
    </div>
  )
}

const Commentcomp = ({ authorName = 'Anonyme', content, publishedDate }) => {
  return (
    <div className="flex">
      <div className="mr-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-12 h-12 text-orange-200"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="w-full">
        <div className="flex flex-col md:flex-row md:justify-between">
          <div className="text-lg font-medium">{authorName}</div>
          <div className="italic md:not-italic">{dayjs(publishedDate).fromNow()}</div>
        </div>
        <div className="mt-2 md:mt-0">{content}</div>
      </div>
    </div>
  )
}
